import React, { useState, useEffect, useContext } from 'react'
import UpdatesComponent from '../../components/UpdatesComponent';
import UpdatesForm from '../../components/UpdatesForm';
import Table from '../../components/Table';
import { AuthContext } from '../../context/AuthContext';
import { api } from '../../api/axios';
import { tableDateFormate } from '../../utils/dateHelper';
import { Eye, EyeOff, Trash, Pen, Image } from 'lucide-react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { fileUlr } from '../../api/url';
import Modal from '../../components/Modal';
import PaginationBar from '../../components/PaginationBar';

const PAGE_SIZE = 20;


const tableHeadingdata = ["#", "Title", "Description", "Link", "Date", "Action"]



export default function Updates() {
    const { loading } = useContext(AuthContext);
    const [updatesData, setUpdatesData] = useState([]);
    const [page, setPage] = useState(1);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false)
    const [editUpdatesData, setEditUpdatesData] = useState({
        title: '',
        description: '',
        link: ''
    })

    useEffect(() => {
        handelGetData();

    }, [loading])

    const handelGetData = async () => {
        try {
            const response = await api.get('/updates');
            setUpdatesData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handelChangeVisibilityOffUpdates = async (id, isActive) => {
        try {
            const resposns = await api.patch(`/updates/active/${id}`, { isActive: !isActive })

            if (resposns.status === 200) {
                handelGetData();
                toast.success("Updates Visibility Changed Successfully")
            }
        } catch (error) {
            toast.error("Updates Visibility Changed Error")
            console.log(error);
        }
    }

    const handelDeleteUpdates = async (id) => {
        if (!window.confirm('Delete this update? This cannot be undone.')) return;
        try {
            const resposns = await api.delete(`/updates/${id}`)

            if (resposns.status === 200) {
                handelGetData();
                toast.success("Updates Deleted Successfully")
            }

        } catch (error) {
            toast.error("Updates Delete Error")
            console.log(error);
        }
    }

    const handelOpenEditModal = async (data) => {
        setIsEditModalOpen(true)
        setEditUpdatesData({
            id: data._id,
            title: data.title,
            description: data.description,
            link: data.link
        })
    }

    const closeEditModal = () => {
        setIsEditModalOpen(false)
    }

    const handleChangeUpdateEditData = (e) => {
        const { name, value } = e.target;
        setEditUpdatesData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    }

    const handleSubmitUpdatsEditForm = async (e) => {
        e.preventDefault();

        try {
            const resposns = await api.patch(`/updates/${editUpdatesData.id}`, {
                title: editUpdatesData.title,
                description: editUpdatesData.description,
                link: editUpdatesData.link
            })

            if (resposns.status === 200) {
                handelGetData();
                toast.success("Updates Updated Successfully")
                closeEditModal();
            }

        } catch (error) {
            toast.error("Updates Update Error")
            console.log(error);
        }
    }


    return (
        <>

            <UpdatesComponent>
                <UpdatesForm />
                <Table
                    tableHeadingdata={tableHeadingdata}>
                    <>
                        {
                            updatesData.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE).map((item, index) => (
                                <tr className="bg-white border-b hover:bg-gray-100 text-gray-900" key={index}>
                                    <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap">
                                        {(page - 1) * PAGE_SIZE + index + 1}
                                    </th>
                                    <td className="px-6 py-4 font-medium whitespace-nowrap">
                                        {item.title}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap truncate max-w-32">
                                        {item.description}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap truncate max-w-32">
                                        <Link to={item.link}>{item.link}</Link>
                                    </td>
                                    <td className="px-6 py-4">
                                        {tableDateFormate(item.updatedAt)}
                                    </td>
                                    <td className="px-6 py-4 text-right flex gap-6 justify-center">
                                        <button

                                            onClick={() => {
                                                item.image !== '' ?
                                                    window.open(`${fileUlr}/uploads/${item.image}`, "_blank")
                                                    :
                                                    toast.error("No Image Found")
                                            }}
                                            className={`font-medium text-purple-400 dark:text-purple-400 dark:hover:text-purple-800 hover:text-purple-800`}>
                                            <Image />
                                        </button>
                                        <button
                                            onClick={() => handelChangeVisibilityOffUpdates(item._id, item.isActive)}
                                            className="font-medium text-gray-400 dark:text-gray-400 dark:hover:text-gray-800 hover:text-gray-800">
                                            {item.isActive ? <Eye /> : <EyeOff />}
                                        </button>
                                        <button
                                            onClick={() => handelDeleteUpdates(item._id)}
                                            className="font-medium text-red-300 dark:text-red-300 dark:hover:text-red-600 hover:text-red-600">
                                            <Trash />
                                        </button>
                                        <button
                                            onClick={() => handelOpenEditModal(item)}
                                            className="font-medium text-green-300 dark:text-greenblue-300 dark:hover:text-green-600 hover:text-green-600">
                                            <Pen />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        }
                    </>
                </Table>

                <div className="mt-4">
                    <PaginationBar
                        totalItems={updatesData.length}
                        page={page}
                        pageSize={PAGE_SIZE}
                        onChange={setPage}
                    />
                </div>

                {
                    isEditModalOpen && <Modal
                        title={"Edit Updates"}
                        closeModal={closeEditModal}
                    >
                        <form onSubmit={handleSubmitUpdatsEditForm} className='grid grid-cols-6 gap-x-4 gap-y-6 w-[40rem]'>
                            <div className="col-span-6">
                                <label htmlFor="title" className="block text-sm/6 font-medium text-gray-900">
                                    Title <span className='text-sm text-red-400'>*</span>
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="title"
                                        name="title"
                                        type="text"
                                        value={editUpdatesData.title}
                                        onChange={handleChangeUpdateEditData}
                                        required={true}
                                        className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                    />
                                </div>
                            </div>
                            <div className="col-span-6">
                                <label htmlFor="description" className="block text-sm/6 font-medium text-gray-900">
                                    Description <span className='text-sm text-red-400'>*</span>
                                </label>
                                <div className="mt-2">
                                    <textarea
                                        id="description"
                                        name="description"
                                        type="text"
                                        value={editUpdatesData.description}
                                        onChange={handleChangeUpdateEditData}
                                        required={true}
                                        rows={5}
                                        className=" px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                    ></textarea>
                                </div>
                            </div>

                            <div className="col-span-6">
                                <label htmlFor="link" className="block text-sm/6 font-medium text-gray-900">
                                    Link <span className='text-sm text-gray-400'>(optional)</span>
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="link"
                                        name="link"
                                        type="text"
                                        value={editUpdatesData.link}
                                        onChange={handleChangeUpdateEditData}
                                        className=" px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                    />
                                </div>
                            </div>
                            <div className="col-span-6 flex justify-center">
                                <button
                                    type="submit"
                                    className="rounded-md bg-green-600 w-full px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                                >
                                    Save Updates
                                </button>
                            </div>
                        </form>

                    </Modal>
                }


            </UpdatesComponent >

        </>
    )
}
